import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFees = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#ffd27e",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 15V1.93333C13.5 1.6858 13.4034 1.4484 13.2315 1.27337C13.0596 1.09833 12.8264 1 12.5833 1H3.41667C3.17355 1 2.94039 1.09833 2.76849 1.27337C2.59658 1.4484 2.5 1.6858 2.5 1.93333V15L4.33333 13.1333L6.16667 15L8 13.1333L9.83333 15L11.6667 13.1333L13.5 15Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00247 4.47695V3.61774",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.29119 4.47681H7.54442C7.27633 4.4765 7.01651 4.56961 6.80965 4.74013C6.60279 4.91065 6.46181 5.14792 6.41095 5.41114C6.3601 5.67436 6.40255 5.94707 6.53101 6.18238C6.65947 6.41768 6.8659 6.60087 7.11481 6.70045L8.88736 7.4093C9.13572 7.50922 9.34156 7.69245 9.46959 7.92755C9.59762 8.16266 9.63986 8.43498 9.58906 8.69782C9.53826 8.96066 9.39759 9.19763 9.19117 9.3681C8.98476 9.53856 8.72546 9.63189 8.45776 9.63207H6.71356",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00247 10.4914V9.6322",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFees;
